import { useEffect, useRef, useState } from "react";

/**
 * Recharts ResponsiveContainer often measures 0×0 when mounted inside flex/grid
 * panels or right after a display toggle. Measure the container directly instead.
 */
export function useChartWidth(defaultWidth = 640) {
    const containerRef = useRef(null);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const node = containerRef.current;
        if (!node) {
            return undefined;
        }

        const updateWidth = () => {
            const measured = Math.floor(node.getBoundingClientRect().width);
            if (measured > 0) {
                setWidth(measured);
            }
        };

        updateWidth();

        const frame = requestAnimationFrame(updateWidth);

        if (typeof ResizeObserver !== "undefined") {
            const observer = new ResizeObserver(updateWidth);
            observer.observe(node);
            window.addEventListener("resize", updateWidth);
            return () => {
                cancelAnimationFrame(frame);
                observer.disconnect();
                window.removeEventListener("resize", updateWidth);
            };
        }

        window.addEventListener("resize", updateWidth);
        return () => {
            cancelAnimationFrame(frame);
            window.removeEventListener("resize", updateWidth);
        };
    }, []);

    return [containerRef, width > 0 ? width : defaultWidth];
}
